import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp } from '@nu-art/thunderstorm-frontend/index';
import './Graph_Referencable.scss';
import { graphviz } from 'd3-graphviz';
import { generateReferencableGraphStringV2 } from './utils.js';
import { ModuleFE_Referencable } from '../ModuleFE_Referencable.js';
import { Component_ReferencableViewer } from '../Component_ReferencableViewer/Component_ReferencableViewer.js';
import { exists } from '@nu-art/ts-common';
import React from 'react';
export class Graph_Referencable extends ComponentSync {
    graphContainerRef = React.createRef();
    depth = 3;
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.graphString = generateReferencableGraphStringV2(nextProps.referencable, this.depth);
        //Reset selected & hovered referencables when re-calculating graph
        state.selectedReferencable = undefined;
        state.hoveredReferencable = undefined;
        return state;
    }
    componentDidMount() {
        this.renderGraph();
    }
    componentDidUpdate() {
        this.renderGraph();
        this.markElements();
    }
    // ######################## Logic ########################
    getGraphEventReferencable = (e) => {
        const target = e.target;
        if (target.tagName.toLowerCase() === 'svg')
            return;
        const nearestGroup = target.closest('g');
        if (!nearestGroup)
            return;
        return ModuleFE_Referencable.cache.unique(nearestGroup.id);
    };
    onGraphClick = (e) => {
        const referencable = this.getGraphEventReferencable(e);
        this.setState({ selectedReferencable: referencable });
    };
    onGraphMouseMove = (e) => {
        const target = e.target;
        //Clear hovered referencable
        if (target.tagName.toLowerCase() === 'svg' && exists(this.state.hoveredReferencable))
            return this.setState({ hoveredReferencable: undefined });
        const referencable = this.getGraphEventReferencable(e);
        if (referencable?._id === this.state.hoveredReferencable?._id)
            return;
        this.setState({ hoveredReferencable: referencable });
    };
    onGraphContext = (e) => {
        if (!exists(this.props.getContextMenuActions))
            return;
        const referencable = this.getGraphEventReferencable(e);
        if (!referencable)
            return;
        const actions = this.props.getContextMenuActions(referencable);
        if (!actions.length)
            return;
        const model = {
            id: 'referencable-graph__menu',
            originPos: { x: e.clientX, y: e.clientY },
            modalPos: { x: 1, y: 1 },
            content: () => actions.map((action, index) => {
                return _jsx(Button, { variant: 'text', onClick: () => {
                        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        action.action();
                    }, children: action.label }, index);
            })
        };
        this.setState({ hoveredReferencable: undefined }, () => ModuleFE_MouseInteractivity.showContent(model));
    };
    markElements = () => {
        const selectedId = this.state.selectedReferencable?._id;
        const container = this.graphContainerRef.current;
        if (!selectedId || !container)
            return;
        //Mark selected node
        const id = CSS.escape(selectedId);
        const selectedRefNode = container.querySelector(`g.node#${id}`);
        selectedRefNode?.classList.add('selected');
    };
    // ######################## Render ########################
    render() {
        return _jsxs("div", { id: 'referencable-graph', ref: this.graphContainerRef, onClick: this.onGraphClick, onMouseMove: this.onGraphMouseMove, onContextMenu: this.onGraphContext, children: [_jsx(Component_ReferencableViewer, { referencable: this.state.selectedReferencable, className: 'selected' }), _jsx(Component_ReferencableViewer, { referencable: this.state.hoveredReferencable, className: 'hovered' })] });
    }
    renderGraph = () => {
        if (!this.state.graphString)
            return;
        const container = this.graphContainerRef.current;
        if (!container)
            return;
        const rect = container.getBoundingClientRect();
        graphviz(container, {
            useWorker: false,
            width: rect.width,
            height: rect.height,
            engine: 'dot'
        })
            .renderDot(this.state.graphString);
    };
}
//# sourceMappingURL=Graph_Referencable.js.map